document.addEventListener('DOMContentLoaded', function() {
    // 1. Find all the featured product sections
    const sections = document.querySelectorAll('.section-featured-product');

    // 2. If we found any, proceed to wrap them
    if (sections.length > 0) {
        // Create the new wrapper div
        const wrapper = document.createElement('div');
        wrapper.id = 'custom-featured-prod';

        // Insert the wrapper right before the first section in the DOM
        sections[0].parentNode.insertBefore(wrapper, sections[0]);

        // Move all the found sections inside the new wrapper
        sections.forEach(function(section) {
            wrapper.appendChild(section);
        });
    }
});